import { Component, ComponentInterface, Element, h, Host, Listen, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'vds-submenu',
  styleUrl: 'vds-submenu.scss',
  shadow: true,
})
export class VdsSubmenu implements ComponentInterface {

  @Element() el!: HTMLVdsSubmenuElement;

  @Prop({ reflect: true, mutable: true }) hidden: boolean = true;

  @Prop() paddingX: boolean = false;

  @Prop() paddingY: boolean = false;

  @Watch('hidden')
  toggleSubmenu(): void {
    this.hidden ?
      this.toggleStageItemsVisibility(-1) :
      this.setupStageItems();
  }

  @Listen('vdsActive')
  navItemChanged(ev: CustomEvent) {
    ev.cancelBubble = true;
    const target = ev.target as HTMLVdsSubmenuNavitemElement;
    const index = this.getNavItemIndex(target);
    this.toggleStageItemsVisibility(index);
    this.toggleNavItemsActive(index);
  }

  private navItems: HTMLVdsSubmenuNavitemElement[] = [];
  private stageItems: HTMLVdsSubmenuStageElement[] = [];

  private hasNav: boolean;
  private hasStage: boolean;
  private parent?: HTMLElement;

  componentWillLoad() {
    this.hasNav = !!this.el.querySelector('[slot="nav-items"]');
    this.hasStage = !!this.el.querySelector('[slot="stage"]');
    this.parent = this.el.parentElement;
  }

  render() {
    const { hidden, hasNav, hasStage, parent, paddingX, paddingY } = this;

    return (
      <Host class={{
        'hidden': hidden,
        'block': !hidden
      }}>
        <div
          class={{
            'w-full h-full gap-0 divide-x divide-grey-lighter': true,
            'grid grid-cols-4': parent.nodeName === "VDS-MENU" && hasStage && hasNav,
            'grid grid-cols-3': parent.nodeName !== "VDS-MENU" && hasStage && hasNav,
            'hidden': !hasStage && !hasNav
          }}>

          <div class={{
            'col-span-1 h-full max-h-full flex flex-col justify-between overflow-x-visible': true,
            'px-6': paddingX && parent.nodeName !== "VDS-MENU",
            'pl-6': paddingX && parent.nodeName === "VDS-MENU",
            'py-6': paddingY
          }}>

            <div class={{
              'flex flex-col justify-between grow shrink basis-0 overflow-y-auto pt-4': true,
              'pr-6': paddingX && parent.nodeName === "VDS-MENU",
            }}>
              <ul class="list-none">
                <slot name="nav-items"></slot>
              </ul>
              <ul class="list-none pt-4">
                <slot name="meta-items"></slot>
              </ul>
            </div>

            <div class={{
              "flex flex-wrap justify-start gap-x-4 gap-y-2 py-4": true,
            }}>
              <slot name="social-media-items"></slot>
            </div>

          </div>

          <div class={{
            'h-full overflow-hidden': true,
            'col-span-3': parent.nodeName === "VDS-MENU",
            'col-span-2': parent.nodeName !== "VDS-MENU",
            }}>
            <slot name="stage"></slot>
          </div>

        </div>
        <slot name="search"></slot>
      </Host>
    );
  }

  componentDidRender(): void {
    this.initialize();

    if (!this.hidden) {
      this.setupStageItems();
    }
  }

  private initialize(): void {
    this.stageItems = Array.from(this.el.querySelectorAll<HTMLVdsSubmenuStageElement>(':scope > vds-submenu-stage'));
  }

  private setupStageItems(): void {
    const navItems = this.navItems = Array.from(this.el.querySelectorAll<HTMLVdsSubmenuNavitemElement>(':scope > li > vds-submenu-navitem'));
    const index = navItems.findIndex(x => x.active);
    this.toggleStageItemsVisibility(index > -1 ? index : 0);
  }

  private getNavItemIndex(item: HTMLVdsSubmenuNavitemElement): number {
    return this.navItems.findIndex(x => x === item);
  }

  private toggleNavItemsActive(index: number): void {
    this.navItems
      .forEach((x, i) => {
        if (i !== index) {
          x.active = false;
        }
      });
  }

  private toggleStageItemsVisibility(index: number): void {
    this.stageItems.forEach((x, i) => {
      if (i === index) {
        this.setStageVisibility(x, true);
      }
      else {
        this.setStageVisibility(x, false);
      }
    });
  }

  private setStageVisibility(stage: HTMLVdsSubmenuStageElement, visible: boolean): void {
    if (visible) {
      stage.hidden = false;
    }
    else {
      stage.hidden = true;
    }
  }

}
